/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_D4tInputs */

const en_mk_sol_startup_d4t = /** @type {(inputs: Mk_Sol_Startup_D4tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End of week: decisions are stored as memory`)
};

const id_mk_sol_startup_d4t = /** @type {(inputs: Mk_Sol_Startup_D4tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akhir minggu: keputusan tersimpan sebagai memori`)
};

/**
* | output |
* | --- |
* | "End of week: decisions are stored as memory" |
*
* @param {Mk_Sol_Startup_D4tInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_d4t = /** @type {((inputs?: Mk_Sol_Startup_D4tInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_D4tInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_d4t(inputs)
	return en_mk_sol_startup_d4t(inputs)
});